import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { ProfileService } from '../../services/profile.service';

@Component({
  selector: 'hadsup-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss',
  standalone: false,
})
export class NavBarComponent {
  @ViewChild('toggleButton') toggleButton: ElementRef | any;
  @ViewChild('menu') menu: ElementRef | any;
  public isMenuOpen: boolean = false;
  public isSettingsMenuOpen = false;
  public currentUrl: string = '';
  public companyLogo: string = '';
  constructor(
    private renderer: Renderer2,
    private storageService: StorageService,
    private router: Router,
    private elRef: ElementRef,
    private globalService: GlobalService,
    private profileService: ProfileService
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (
        this.isMenuOpen &&
        !this.elRef.nativeElement.contains(e.target) &&
        e.target !== this.toggleButton?.nativeElement
      ) {
        this.closeMenu();
      }
    });
  }
  ngOnInit() {
    this.GetProfileDetails();
    this.globalService.currentLogo.subscribe((newLogoUrl: any) => {
      if (newLogoUrl) {
        this.companyLogo = newLogoUrl || this.companyLogo;
      }
    });
  }
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }
  toggleSettingsMenu(): void {
    this.isSettingsMenuOpen = !this.isSettingsMenuOpen;
  }

  logout(): void {
    this.storageService.removeAll();
    localStorage.clear();
    this.router.navigateByUrl('/login');
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
  closeModelOnOverlay(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeMenu();
    }
  }
  GetProfileDetails() {
    this.profileService.GetCompanyLogo().subscribe((response: any) => {
      if (response) {
        const data = response.data;
        if (
          data.relations &&
          data.relations.companyLogo &&
          data.relations.companyLogo.length > 0
        ) {
          this.companyLogo = data.relations.companyLogo[0].url;
        } else {
          this.companyLogo = './assets/images/hadsup-logo.svg';
        }
      }
    });
  }
}
